"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("../../helpers/index.js");

var _index2 = require("../../utils/index.js");

var _excluded = ["pageName", "province", "pageLanguage", "lob", "pageType", "siteGenerator", "knowledgeBaseArticleID", "knowledgeBaseArticleType", "knowledgeBaseArticleCategory", "userAccountType", "userAccountID", "loyaltyID", "loyaltyTier", "userLoginStatus", "banType", "prodElig", "catalogueType", "prodAvail", "subscriptionID", "banCount", "subCount", "accountRole", "encryptedBan", "wifiID", "prospectID", "eKnowID", "rcid", "colophonID", "dataTotal", "urlRedirect", "orderBasedDrop", "wirelineAccounts", "accessMotion", "accessVoice", "displayMode", "fontSize", "billCycleEnd", "billCycleStart", "prodOwned", "subKey", "subID", "overageFlag", "dataUsed", "dataRemaining", "daysRemaining", "userSystem", "userStatus", "tvType", "internetType", "offerType", "orderType"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Keys that cannot be customized since they have a default value or works with a custom behavior
var lockedFields = ['edgeServer', 'customPageViews', 'customSiteSection', 'primarySiteSection', 'secondarySiteSection', 'tertiarySiteSection', 'quaternarySiteSection', 'pageURL', 'previousPageType', 'site', 'webApp', 'dataLayerType', 'tagManager', 'adobeDataLayerBuilder'];

var getBaseTemplate = function getBaseTemplate(_ref) {
  var _window$__LOCALE__, _window$__LOCALE__2;

  var pageName = _ref.pageName,
      province = _ref.province,
      pageLanguage = _ref.pageLanguage,
      lob = _ref.lob,
      pageType = _ref.pageType,
      siteGenerator = _ref.siteGenerator,
      knowledgeBaseArticleID = _ref.knowledgeBaseArticleID,
      knowledgeBaseArticleType = _ref.knowledgeBaseArticleType,
      knowledgeBaseArticleCategory = _ref.knowledgeBaseArticleCategory,
      userAccountType = _ref.userAccountType,
      userAccountID = _ref.userAccountID,
      loyaltyID = _ref.loyaltyID,
      loyaltyTier = _ref.loyaltyTier,
      userLoginStatus = _ref.userLoginStatus,
      banType = _ref.banType,
      prodElig = _ref.prodElig,
      catalogueType = _ref.catalogueType,
      prodAvail = _ref.prodAvail,
      subscriptionID = _ref.subscriptionID,
      banCount = _ref.banCount,
      subCount = _ref.subCount,
      accountRole = _ref.accountRole,
      encryptedBan = _ref.encryptedBan,
      wifiID = _ref.wifiID,
      prospectID = _ref.prospectID,
      eKnowID = _ref.eKnowID,
      rcid = _ref.rcid,
      colophonID = _ref.colophonID,
      dataTotal = _ref.dataTotal,
      urlRedirect = _ref.urlRedirect,
      orderBasedDrop = _ref.orderBasedDrop,
      wirelineAccounts = _ref.wirelineAccounts,
      accessMotion = _ref.accessMotion,
      accessVoice = _ref.accessVoice,
      displayMode = _ref.displayMode,
      fontSize = _ref.fontSize,
      billCycleEnd = _ref.billCycleEnd,
      billCycleStart = _ref.billCycleStart,
      prodOwned = _ref.prodOwned,
      subKey = _ref.subKey,
      subID = _ref.subID,
      overageFlag = _ref.overageFlag,
      dataUsed = _ref.dataUsed,
      dataRemaining = _ref.dataRemaining,
      daysRemaining = _ref.daysRemaining,
      userSystem = _ref.userSystem,
      userStatus = _ref.userStatus,
      tvType = _ref.tvType,
      internetType = _ref.internetType,
      offerType = _ref.offerType,
      orderType = _ref.orderType,
      rest = _objectWithoutProperties(_ref, _excluded);

  var cleanedRest = (0, _index2.removeLockedKeys)(rest, lockedFields);
  var pageNameValues = (0, _index.getPageNameValues)();
  var uuid = (0, _index.getUserAccountID)();
  var siteSections = pageNameValues.siteSections;
  var pageNameValue = pageName || pageNameValues.pageName;
  return {
    pageViews: {
      value: 1
    },
    name: pageNameValue,
    URL: document.location.href,
    server: document.location.origin,
    siteSection: siteSections[0],
    _telus: _objectSpread({
      customPageViews: 1,
      pageName: pageNameValue,
      province: province || ((_window$__LOCALE__ = window.__LOCALE__) === null || _window$__LOCALE__ === void 0 ? void 0 : _window$__LOCALE__.prov),
      pageLanguage: pageLanguage || ((_window$__LOCALE__2 = window.__LOCALE__) === null || _window$__LOCALE__2 === void 0 ? void 0 : _window$__LOCALE__2.lang),
      customSiteSection: siteSections[0],
      primarySiteSection: siteSections[1],
      secondarySiteSection: siteSections[2],
      tertiarySiteSection: siteSections[3],
      quaternarySiteSection: siteSections[4],
      pageURL: window.location.href,
      queryString: window.location.href,
      site: 'website',
      userAccountID: userAccountID || uuid,
      webApp: 'web',
      dataLayerType: 'acdl',
      brand: 'telus',
      edgeServer: 'edge.adobedc.net',
      tagManager: 'adobe_launch',
      adobeDataLayerBuilder: 'alloyAnalytics',
      lob: lob,
      pageType: pageType,
      siteGenerator: siteGenerator,
      knowledgeBaseArticleID: knowledgeBaseArticleID,
      knowledgeBaseArticleType: knowledgeBaseArticleType,
      knowledgeBaseArticleCategory: knowledgeBaseArticleCategory,
      userAccountType: userAccountType,
      loyaltyID: loyaltyID,
      loyaltyTier: loyaltyTier,
      userLoginStatus: userLoginStatus,
      banType: banType,
      prodElig: prodElig,
      catalogueType: catalogueType,
      prodAvail: prodAvail,
      subscriptionID: subscriptionID,
      banCount: banCount,
      subCount: subCount,
      accountRole: accountRole,
      encryptedBan: encryptedBan,
      wifiID: wifiID,
      prospectID: prospectID,
      eKnowID: eKnowID,
      rcid: rcid,
      colophonID: colophonID,
      dataTotal: dataTotal,
      urlRedirect: urlRedirect,
      orderBasedDrop: orderBasedDrop,
      wirelineAccounts: wirelineAccounts,
      accessMotion: accessMotion,
      accessVoice: accessVoice,
      displayMode: displayMode,
      fontSize: fontSize,
      billCycleEnd: billCycleEnd,
      billCycleStart: billCycleStart,
      prodOwned: prodOwned,
      subKey: subKey,
      subID: subID,
      overageFlag: overageFlag,
      dataUsed: dataUsed,
      dataRemaining: dataRemaining,
      daysRemaining: daysRemaining,
      userSystem: userSystem,
      userStatus: userStatus,
      tvType: tvType,
      internetType: internetType,
      offerType: offerType,
      orderType: orderType
    }, cleanedRest)
  };
};

var _default = getBaseTemplate;
exports["default"] = _default;